import React, { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import { useSelector } from "react-redux";
import { client_name, Theme } from "../../../../Helpers/request";
import BannerSlider from "./Components/Bannerslider";
import ShopByDiamondShape from "./Components/ShopByDiamondShape";
import ExploreCollection from "./Components/ExploreCollection";
import DesignDiamondRing from "./Components/DesignDiamondRing";
import ShopRingByStyle from "./Components/ShopRingByStyle";
import GemstoneGlamour from "./Components/GemstoneGlamour";
import CustomDesign from "./Components/CustomDesign";
import ConsultSpecialist from "./Components/ConsultSpecialist";
import Customer from "./Components/Customer";
import Insta from "./Components/insta";
import SignupTo from "./Components/SignupTo";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import Snowfall from "react-snowfall";
// import "./Assets/showcase.css";


// if(Theme === 'showcase'){
// require(`./assets/css/showcase.css`);
// }
const ShowcaseHome = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const history = useHistory();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      // disable: 'mobile'
    });
  }, []);

  return (
    <>
      
      {/* <div className="al_snowfall" style={{ height: '100%', width: '100%', background: '#282c34', overflow: 'hidden' }}>
        <Snowfall  color="#fff"   snowflakeCount={250}  className="al_snowfall_canvas" />
      </div> */}
      <div className="LandingPageShocase ShowcaseThemHome">
        <BannerSlider />
        <ShopByDiamondShape />
        <ExploreCollection />
        <DesignDiamondRing />
        <ShopRingByStyle />
        <GemstoneGlamour />
        <CustomDesign />
        <ConsultSpecialist />
        <Customer />
        <Insta />
        <SignupTo />
      </div>
    </>
  );
};

export default ShowcaseHome;
